
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-06-10-yuebing-part-2",
      function () {
        return require("private-next-pages/blogs/2023-06-10-yuebing-part-2/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-06-10-yuebing-part-2"])
      });
    }
  